/** Canonical output label — matches consumerContractRegistry.summaryFields extenders_mm. */
export const EXTENDERS_MM_OUTPUT_LABEL = 'Extenders (mm)';

export type ExtenderOptionsLike = {
  ext_top_mm?: unknown;
  ext_bottom_mm?: unknown;
  ext_left_mm?: unknown;
  ext_right_mm?: unknown;
};

function extenderMm(value: unknown): number {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
}

/** Global display format for frame extenders from specs.options. Empty when all zero. */
export function formatExtendersMmFromOptions(options: ExtenderOptionsLike | null | undefined): string {
  if (!options) return '';
  const t = extenderMm(options.ext_top_mm);
  const b = extenderMm(options.ext_bottom_mm);
  const l = extenderMm(options.ext_left_mm);
  const r = extenderMm(options.ext_right_mm);
  if (!(t || b || l || r)) return '';
  return `T${t} B${b} L${l} R${r}`;
}

export function hasFrameExtenders(options: ExtenderOptionsLike | null | undefined): boolean {
  return formatExtendersMmFromOptions(options).length > 0;
}
